import { render } from "./studioManage.vue?vue&type=template&id=72e5fe6b&scoped=true"
import script from "./studioManage.vue?vue&type=script&lang=js"
export * from "./studioManage.vue?vue&type=script&lang=js"

import "./studioManage.vue?vue&type=style&index=0&id=72e5fe6b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e5fe6b"]])

export default __exports__